var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container body"},[_c('div',{staticClass:"main_container"},[_c('Sidebar'),_c('Header'),_c('div',{staticClass:"right_col",staticStyle:{"min-height":"987px"},attrs:{"role":"main"}},[_c('router-view')],1),_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }